/* eslint-disable */
import { FuseNavigationItem } from '@fuse/components/navigation';
import {adminNavigation} from "../../../navigations/admin-navigation";

export const defaultNavigation: FuseNavigationItem[] = adminNavigation
export const compactNavigation: FuseNavigationItem[] = adminNavigation
export const futuristicNavigation: FuseNavigationItem[] = adminNavigation
export const horizontalNavigation: FuseNavigationItem[] = adminNavigation
